import { Injectable, Injector, Renderer2, RendererFactory2 } from '@angular/core';
import { translate, TranslocoService } from '@jsverse/transloco';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppInjector } from 'app/app.module';
import { UploadsService } from 'app/global/uploads.service';
import { Block } from 'app/interfaces/blocks';
import { contentBlock } from 'app/interfaces/contentBlock';
import { DroplistOptions, Field } from 'app/interfaces/fields';
import { HelperService } from 'app/main/pages/edit-template/helper.service';
import { EditorEmitterService } from 'app/main/pages/events/editor-emitter.service';
import { Blocks } from 'app/main/pages/general-editor-tabs/blocks/blocks';
import { AssignRoleComponent } from 'app/main/pages/general-editor-tabs/content-library-tab/assign-role/assign-role.component';
import { ContentLibraryTabComponent } from 'app/main/pages/general-editor-tabs/content-library-tab/content-library-tab.component';
import { PopOver } from 'app/main/pages/general-editor-tabs/popover/popover';
import { SignatureComponent } from 'app/main/pages/profile-settings/signature/signature.component';
import { GenerateSignature, SignatureType } from 'app/main/pages/profile-settings/signature/signature.dto';
import { SignatureBoxComponent } from 'app/main/signing-pages/signature-box/signature-box.component';
import { Signature } from 'app/main/signing-pages/signature-box/signature-box.dto';
import { SigningHelperService } from 'app/main/signing-pages/signing-page/signing-page-helper';
import { SingingPageService } from 'app/main/signing-pages/signing-page/signing-page-service';
import feather from 'feather-icons';
import { AngularRenderer } from 'ngx-tiptap';
import { lastValueFrom, take, timer } from 'rxjs';
import uuid from 'short-unique-id';
import Swal, { SweetAlertResult } from 'sweetalert2';
import tippy from 'tippy.js';
import { generateCalculation } from './calculation';
import { DocumentFieldEmitterService } from './documentfield-emitter.service';
import { AreaType, ContentBoxAction, Options } from './dom-handler.dto';
import { DomHelperService } from './dom-helper.service';
import { applyRelations, resetRelation } from './fieldrelation';
import { onFieldValidation } from './fieldvalidation';
import { GlobalService } from './global.service';
import { TagPopoverComponent } from './tag-popover/tag-popover.component';
import { TippyWrapperService } from './tippy-wrapper.service';
import { PopoverSettingMenu } from 'app/main/pages/edit-template/edit-template.dto';
import { OnlineContractEventEmitterService } from 'app/main/online-contract/online-contract/online-contract-event-emitter.service';
import { RefreshFileService } from 'app/main/signing-pages/helpers/refresh-file.service';
import { SessionImageService } from './session-image.service';
import { DocumentFieldService } from 'app/main/pages/settings/documentfields/documentfield.service';
import { JsonFileDTO } from 'app/main/pages/settings/documentfields/meta-data-form/JsonFileDTO.dto';
import { EditTemplateFacade } from 'app/main/pages/edit-template/store/edit-template-store.facade';
import { UserGalleryComponent } from 'app/main/pages/general-modals/user-gallery/user-gallery.component';
import { Fields } from 'app/main/pages/general-editor-tabs/fields/fields';
import { ContentTabService } from 'app/main/pages/general-editor-tabs/content-tab/content-tab.service';
import { ValidationHandlerService } from './validation-handler/validation-handler.service';
import { FieldRenderService } from 'app/main/pages/edit-template/field-render.service';
import { ReusableAttachmentService } from './reusable-attachment.service';
import { ProductTableModalsComponent } from 'app/main/pages/general-modals/product-table-modals/product-table-modals.component';
import {productTable} from 'app/main/pages/general-editor-tabs/product-table/productTable';

interface DroplistTreeOption extends DroplistOptions {
    children: DroplistTreeOption[];
}

declare const $;
@Injectable({
    providedIn: 'root'
})

export class DomHandlersService {
    private renderer: Renderer2;
    private apiFieldCache = new Map<number, { option_name: string }[]>();
    public uuid = new uuid({ length: 6, dictionary: 'number' });
    constructor(
        private globalService: GlobalService,
        private documentFieldService: DocumentFieldService,
        private editorEmitterService: EditorEmitterService,
        private rendererFactory: RendererFactory2,
        private emitter: DocumentFieldEmitterService,
        private modalService: NgbModal,
        private uploads: UploadsService,
        private singingPageService: SingingPageService,
        private Blocks: Blocks,
        private _translocoService: TranslocoService,
        private popOver: PopOver,
        private helperService: HelperService,
        private signingHelperService: SigningHelperService,
        private tippyWrapperService: TippyWrapperService,
        private injector:Injector,
        private onlineContractEventEmitterService: OnlineContractEventEmitterService,
        private refreshFileService:RefreshFileService,
        private sessionImageService: SessionImageService,
        private editTemplateFacade: EditTemplateFacade,
        private _fieldRenderService: FieldRenderService,
        private fields:Fields,
        private validationHandlerService:ValidationHandlerService,
        private productTable: productTable
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    /**
     * open the field setting automatically when already open the righr side menu
     * @param event 
     */
    openFieldSettings(event: MouseEvent) {
        const targetElement = event;
        const parentNode = (targetElement.target as HTMLElement).closest('.content-field-inner');
        if(parentNode){
            const uuid = parentNode.getAttribute('editor-uuid');
            const fieldData: Field = this.globalService.fields_data[uuid];
            if (!fieldData) {
                console.warn('[openFieldSettings] field data missing for uuid', uuid);
                return;
            }
            this.editorEmitterService.triggerEmitter({ uuid: uuid, field_name: fieldData['field_name'], selected_field: fieldData['selected_field'], isFormBuilder: 0, formUuid: 0, isFieldBlock: fieldData['field_block'], autoOpenSettings: true });
        }
    }

    /**
     * toggle the pdf break or page break
     * @param event 
     */
    convertToPdfOrPageBreak(event: MouseEvent) {
        const targetElement = event;
        const uuid = (targetElement.target as HTMLElement).closest('.block-action-menu').getAttribute('uuid');
        const blockData: Block = {...this.globalService.fields_data['blocks'][uuid]};
        const element = document.querySelector('.add-longpage-break[uuid="' + uuid + '"]');
        if (blockData.type == 'page-break') {
            this.globalService.updateBlock(uuid, { type: 'pdf-break', name: 'PDF Break' });
            this.renderer.removeClass(element, 'page-break');
            this.renderer.addClass(element, 'pdf-break');
        } else {
            this.globalService.updateBlock(uuid, { type: 'page-break', name: 'Page Break' });
            this.renderer.removeClass(element, 'pdf-break');
            this.renderer.addClass(element, 'page-break');
        }
    }

    /**
     * add the svg icon when hover on content box
     * @param event 
     */
    mouseEnterOnContentBox(event: MouseEvent) {
        const targetElement = event;
        const contentBox = (targetElement.target as HTMLElement)?.closest('.content-box');
        if (!contentBox) {
            console.warn('[mouseEnterOnContentBox] content box missing for event target', event);
            return;
        }
        const contentBoxInner = (contentBox.querySelector('.content-box-inner') as HTMLElement);
        if (contentBoxInner) {
            contentBox.classList.contains('page-break-block') ? 'Page break' : contentBoxInner.getAttribute('type');
        }
    }

    /**
     * remove the icons when mouse out
     * @param event 
     */
    mouseLeaveOnContentBox(event: MouseEvent) {
        const targetElement = event;
        const contentBox = (targetElement.target as HTMLElement)?.closest('.content-box');
        if (!contentBox) {
            console.warn('[mouseLeaveOnContentBox] content box missing for event target', event);
            return;
        }
        const sortHelper = contentBox.querySelector('.sort-helper');
        if (sortHelper) {
            sortHelper.innerHTML = '';
        }
    }

    /**
     * add Three Dots svg icon when hover on content box Inner
     * @param event 
     */
    mouseEnterOnContentBoxInner(event: MouseEvent) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event.target as HTMLElement;
        const blockAction = element.querySelector('.block-action-btn');
        const blockSortInner = element.querySelector('.block-sort-inner-div');
        const blockSort = element.querySelector('.block-sort');
        const contentBoxBlock = element?.closest('.content-box');
        const uuid = blockAction.getAttribute('uuid');
        if (!element) {
            console.warn('[mouseEnterOnContentBoxInner] event target missing', event);
            return;
        }

        let field: Field | Block | undefined;
        try {
            field = this.globalService?.fields_data?.[uuid];
            if (typeof field === 'undefined' && this.globalService?.fields_data?.['blocks']) {
                field = { ...this.globalService?.fields_data['blocks']?.[uuid] } as Block;
            }
        } catch (err) {
            console.warn('[mouseEnterOnContentBoxInner] error reading globalService.fields_data', err);
            field = undefined;
        }

        if (!field) {
            console.warn('[mouseEnterOnContentBoxInner] field data missing for uuid', uuid);
            return;
        }
        let sortIcon = '<span><svg viewBox="0 0 24 24" role="presentation" width="25" height="25" class="sort-icon"><path d="M9 7h2v2H9V7zm0 4h2v2H9v-2zm0 4h2v2H9v-2zm4-8h2v2h-2V7zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z" fill-rule="evenodd"></path></svg></span>';
        let tooltipText = ``;
        if(field?.is_locked === 1) {
            sortIcon = `<span>${feather.icons['lock'].toSvg({ class: `cursor-pointer`, width: 14, height: 14 })}</span>`
        }
        if(field?.hidden === 1){
            tooltipText = field?.connected_parent_conditional_id?.map(item => item.name).join(', ');
            sortIcon += `<span class="cursor-pointer" id="conditaional-info"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" stroke-width="1.75"> <path d="M12 9h.01"></path> <path d="M11 12h1v4h1"></path> <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"></path> </svg></span>`;
        }
        if (blockAction && !contentBoxBlock?.classList?.contains('active-menu')) {
            this.renderer.setProperty(blockAction, 'innerHTML', feather.icons['more-vertical'].toSvg({ class: `cursor-pointer`, width: 14, height: 14 }))
        }
        if (blockSortInner) {
            this.renderer.setProperty(blockSortInner, 'innerHTML', sortIcon);
        }
        if(field?.hidden === 1){
            tippy('#conditaional-info', {
                content: `<div class="conditaional-info p-50">Conditional: ${tooltipText}</div>`,
                allowHTML: true,
                onHidden(instance) {
                    instance.destroy();
                },
            });
        }
        this.editTemplateFacade.template$.pipe(take(1)).subscribe((template) => {
            if(template?.template?.can_edit === false && field.is_locked === 1) {
                if(blockAction) this.renderer.addClass(blockAction, 'hidden');
                if(blockSort) this.renderer.addClass(blockSort, 'stop-sorting');
            }else {
                if(blockAction) this.renderer.removeClass(blockAction, 'hidden');
                if(blockSort) this.renderer.removeClass(blockSort, 'stop-sorting');
            }
        });
        domHelperService.initializeEventListener('.open-editor-menu', 'click', 'openBlockMenu');
    }

    /**
     * remove the icons when mouse out
     * @param event 
     */
    mouseLeaveOnContentBoxInner(event: MouseEvent) {
        const element = event.target as HTMLElement;
        // element.querySelector('.block-action-btn').innerHTML = '';
        const blockSort = element.querySelector('.block-sort-inner-div');
        if (blockSort) {
            // this.renderer.setProperty(blockSort, 'innerHTML', '');
        }
    }

    /**
     * Add SVG Icons to the icon box based on the lock state and content type.
     * @param isLocked 
     * @param contentType 
     * @returns 
     */
    addSvgIcons(isLocked: HTMLElement, contentType: string) {
        const lockIcon = feather.icons.lock.toSvg({ class: 'lock-icon', width: 12, height: 12 });
        const sortIcon = '<svg viewBox="0 0 24 24" role="presentation" width="25" height="25" class="sort-icon"><path d="M9 7h2v2H9V7zm0 4h2v2H9v-2zm0 4h2v2H9v-2zm4-8h2v2h-2V7zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z" fill-rule="evenodd"></path></svg>';
        const icon = isLocked ? lockIcon : sortIcon;
        return icon + this.iconBox(contentType);
    }


    /**
     * Generates an HTML string for a content box with an icon and a class name.
     *
     * @param contentType - The type of content to be displayed in the box.
     * @param className - Optional CSS class name to apply to the box (default is 'highlightSortContentBox').
     * @returns A string containing the HTML structure for the content box with the specified icon and class.
     */
    iconBox(contentType: string, className: string = 'highlightSortContentBox') {
        return `<div class="${className}">${this.svgIcons(contentType)}</div>`;
    }

    
    /**
     * Returns an SVG icon based on the content type.
     *
     * @param contentType - The type of content for which the icon is to be generated.
     * @returns A string containing the SVG icon HTML.
     *
     * This method generates different SVG icons based on the provided content type,
     * such as 'content box', 'page-break', 'Upload pdf', etc. Each case returns a
     * specific SVG icon along with a descriptive text.
     */
    svgIcons(contentType: string) {
        let icon = '';
        switch (contentType) {
            case 'content box':
                icon = `<p>${translate("Content Box (Template/Document - section) - Content Box")}</p><svg viewBox="0 0 24 24" role="presentation"><path d="M4 4h8v2H9v6H7V6H4V4zM4 16V14h16v2l-16 .001zM4 20v-2h16v2H4zm9-8v-2h7v2h-7z" fill-rule="evenodd"></path></svg>`;
                break;
            case 'page-break':
                icon = `<p>${translate("Content page break (Template/Document - section) - Page break")}</p><svg viewBox="0 0 24 24" role="presentation"><path d="M5 18c.55 0 1-.45 1-1s-.45-1-1-1c-.56 0-1 .45-1 1s.44 1 1 1zM5 8c.55 0 1-.45 1-1s-.45-1-1-1c-.56 0-1 .45-1 1s.44 1 1 1zm12.7-1.29l-5.61 5.62 5.61 5.62c-.78.78-2.05.78-2.83 0l-4.21-4.21-2.72 2.72c.03.18.06.36.06.54 0 1.66-1.35 3-3 3-1.66 0-3-1.34-3-3s1.34-3 3-3c.73 0 1.39.26 1.9.69l2.36-2.36-2.74-2.74c-.44.26-.96.41-1.52.41-1.66 0-3-1.34-3-3s1.34-3 3-3c1.65 0 3 1.34 3 3 0 .37-.08.72-.2 1.04l2.87 2.88h.01l4.19-4.21c.78-.78 2.05-.78 2.83 0zM16 13v-2h2v2h-2zm4 0v-2h1.97v2H20z" fill-rule="evenodd"/></svg>`;
                break;
            case 'Upload pdf':
                icon = `<p>${translate("Content upload PDF Template/Document - section) - Upload PDF")}</p>${feather.icons['file-text'].toSvg({ class: 'cursor-pointer feather-upload', width: 18, height: 18 })}`;
                break;
            case 'product-table':
                icon = `<p>${translate("Content product table (Template/Document - section) - Product Table")}</p><div class="content-item-svgicon"><svg viewBox="0 0 24 24" role="presentation"><path d="M2 20h20V4H2v16zm11-7h7v-3h-7v3zm-9 0h7v-3H4v3zm9 5.001h7V15h-7v3.001zm-9 0h7V15H4v3.001z" fill-rule="evenodd"></path></svg></div>`;
                break;
            case 'attachment':
                icon = `<p>${translate("Content attachment - (Template/Document - section) - Attachment")}</p><svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-paperclip"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>`;
                break;
            case 'image':
                icon = `<p>${translate("Content Image Box (Template/Document - section) - Image Box")}</p>${feather.icons['image'].toSvg({ class: 'cursor-pointer feather-upload', width: 18, height: 18 })}`;
                break;
            case 'form':
                icon = `<p>${translate("Content Form box (Template/Document - section) - Form")}</p><svg width="28" height="28" viewBox="0 0 28 28" fill="currentColor" class="Icon"><path fill-rule="evenodd" d="M2 13V1h24v12H2zm14 14v-2h10v2H16zm0-6v2h10v-2H16zm0-2v-2h10v2H16zM2 17v10h10V17H2zm2-6V3h20v8H4zm0 8v6h6v-6H4z" clip-rule="evenodd"></path></svg>`;
                break;
            case 'table':
                icon = `<p>${translate("Content Table box (Template/Document - section) - Table")}</p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-table"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/></svg>`;
                break;
            case 'text block':
                icon = `<span>${translate("Content text field (Template/Document - section) - Text Field")}</span><div class="content-item-svgicon"><svg viewBox="0 0 24 24" role="presentation"><path d="M19 21V3h2v18h-2zM9.19 6.106h1.62L16 17.959h-2l-1.132-2.735H7.132L6 17.959H4L9.19 6.106zM10 8.84L8.146 13.4h3.708L10 8.841z" fill-rule="evenodd"></path></svg></div>`;
                break;
            case 'checkbox block':
                icon = `<span>${translate("Content check Box field (Template/Document - section) - Check Box")}</span><div class="content-item-svgicon"><svg viewBox="0 0 24 24" role="presentation"><path d="M3 21V3h18v18H3zm2-2h14V5H5v14zM17.722 8.691l-7.42 7.753-4.023-4.18 1.442-1.386 2.577 2.677 5.98-6.247 1.444 1.383z" fill-rule="evenodd"></path></svg></div>`;
                break;
            case 'droplist block':
                icon = `<span>${translate("Content drop list (Template/Document - section) - Drop List")}</span><div class="content-item-svgicon"><svg viewBox="0 0 24 24" role="presentation"><defs><path id="FieldDropdown_svg__a" d="M18 10l-4 5.28L10 10h8zM2 20V4h20v16H2zm2-1.999h16V6H4v12.001z"></path></defs><use xlink:href="#FieldDropdown_svg__a" fill-rule="evenodd"></use></svg></div>`;
                break;
            case 'multichoice block':
                icon = `<span>${translate("Content list field (Template/Document - section) - List")}</span><div class="content-item-svgicon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g data-name="Layer 2"><rect width="10" height="10" x="2" y="18" rx="2"/><path d="M7 13a2.973 2.973 0 0 1-2.12-.88l-1-1A3 3 0 0 1 6 6a3.084 3.084 0 0 1 .68.08L8.76 4H4a2.006 2.006 0 0 0-2 2v6a2.006 2.006 0 0 0 2 2h6a2.006 2.006 0 0 0 2-2V9.24l-2.88 2.88A2.973 2.973 0 0 1 7 13zm8-5h14a1 1 0 0 0 0-2H15a1 1 0 0 0 0 2zm0 4h9a1 1 0 0 0 0-2h-9a1 1 0 0 0 0 2zm14 8H15a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2zm-5 4h-9a1 1 0 0 0 0 2h9a1 1 0 0 0 0-2z"/><path d="M10.293 5.293 7 8.586l-.293-.293a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414Z"/></g></svg></div>`;
                break;
            case 'datepicker block':
                icon = `<span>${translate("Content date picker field (Template/Document - section) - Date Picker")}</span><div class="content-item-svgicon"><svg viewBox="0 0 24 24" role="presentation"><path d="M15 3h2v2h4v16H3V5h4V3h2v2h6V3zM5 19h14V9H5v10zm2-6v-2h2v2H7zm0 4v-2h2v2H7zm4-4v-2h2v2h-2zm0 4v-2h2v2h-2zm4-4v-2h2v2h-2zm0 4v-2h2v2h-2z" fill-rule="evenodd"></path></svg></div>`;
                break;
            case 'signature block':
                icon = `<span>${translate("Content signing box field (Template/Document - section) - Signing Box")}</span><div class="content-item-svgicon"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-signature" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2C3E50" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2" /></svg></div>`;
                break;
            default:
                icon = '';
                break;
        }
        return icon;
    }


   
    
    /**
     * Determines whether a field, identified by its UUID, is allowed to be filled.
     *
     * @param uuid - The unique identifier (string or number) of the field to check.
     * @returns `true` if the field exists and is not locked (`is_locked !== 1`), otherwise `false`.
     */
    private restrictFieldsForFilling(uuid: string | number): boolean { 
        const field: Field = this.globalService.fields_data[uuid];
        if (!field || field.is_locked === 1) {
            return false;
        }
        return true;
    }


    /**
     * update the field when send or role type, eg. calculation relation etc on keyup
     * @param event 
     * @param options 
     */
    updateFieldOnKeyUp(event: KeyboardEvent, options: Options): void {
        if (event.key === 'Backspace') {
          event.stopPropagation(); // Prevent backspace from deleting the mention node
        }
        const element = event.target as HTMLInputElement;
        const parentNode = element.closest('.drag-fields');
        const uuid = element.closest('.drag-fields').getAttribute('uuid');
        if (!this.restrictFieldsForFilling(uuid)) {
            return;
        }
        const field: Field = this.globalService.fields_data[uuid];
        const val = element.value;
        this.renderer.setAttribute(element, 'value', val);
        const textTagElement = parentNode.querySelector('span.text-tag');
        if (textTagElement) {
            this.renderer.setProperty(textTagElement, 'textContent', val === '' ? this.globalService.generateTagText(uuid) : val);
        }
        if (event.key === 'Enter' && !field.allow_multi_lines) {
            this.updateFieldOnBlur(event, options);
        }
        const textAreaSelector = document.querySelector(`.drag-fields[uuid='${uuid}'] textarea`) as HTMLTextAreaElement;
        if(textAreaSelector){
            this.renderer.setProperty(textAreaSelector, 'textContent', val);
            this.globalService.autoHeightForTextarea(textAreaSelector);
        }
        if (field) {
            this.globalService.updateField(uuid, { value: val }, (() => {
                this.emitter.patchData({ uuid: uuid, value: val, refresh: 1 });
                if (element.classList.contains('calculation')) {
                    generateCalculation(uuid, this.globalService, true);
                }
                applyRelations(uuid, this.globalService);
            }));
        }
    }

    

    /**
     * Handles the blur event on an input field, updating the corresponding field data and UI.
     *
     * This method performs the following actions:
     * - Retrieves the input element and its parent `.drag-fields` container.
     * - Extracts the field's UUID and checks if the field is allowed to be filled.
     * - Updates the display text of the associated `.text-tag` span element.
     * - Toggles visibility classes based on the field type.
     * - Updates the field value in the global service and emits relevant events.
     * - Triggers field validation and applies any field relations.
     * - Notifies the online contract event emitter service of the field update.
     *
     * @param event - The keyboard event triggered on blur.
     * @param options - Additional options, including the role ID for validation.
     * 
     * @returns {void}
     */
    updateFieldOnBlur(event: KeyboardEvent, options: Options): void {
        const element = event.target as HTMLInputElement;
        const parentNode = element.closest('.drag-fields');
        const uuid = element.closest('.drag-fields').getAttribute('uuid');
        if(!this.restrictFieldsForFilling(uuid)) return;
        const val = element.value;
        const field:Field = this.globalService.fields_data[uuid];
        const textTagElement = parentNode.querySelector('span.text-tag');
        if (textTagElement) {
            this.renderer.setProperty(textTagElement, 'textContent', !val ? this.globalService.generateTagText(uuid) : val);
        }
        if (field.type_of == 'tag') {
            this.renderer.addClass(element, 'hidden');
            this.renderer.removeClass(textTagElement, 'hidden');
        }

        if (this.globalService.fields_data[uuid]) {
            this.globalService.updateField(uuid, { value: val }, ((updated_field: Field) => {
                this.emitter.patchData({ uuid: uuid, value: val });
                onFieldValidation(updated_field, this.globalService, options.role_id);
                applyRelations(uuid, this.globalService);
            }));
        }
        this.onlineContractEventEmitterService.updateFieldData(field);
        this.validationHandlerService.resetFieldHighlight(uuid);
    }

    /**
     * open a tag popover on click
     * @param event 
     * @param options 
     */
    openTagPopover(event: MouseEvent, options: Options) {
        const element = event.target as HTMLElement;
        const parentNode = element.closest('.drag-fields');
        const uuid = element.closest('.drag-fields').getAttribute('uuid');
        const fieldData: Field = this.globalService.fields_data[uuid];
        const component: AngularRenderer<TagPopoverComponent, TagPopoverComponent> = new AngularRenderer(TagPopoverComponent, this.injector, {});
        const tippy = this.tippyWrapperService.createPopover(parentNode,component.dom, {
            onDestroy: () => {
                component.destroy()
            }
        });
        tippy.show();
        component.updateProps({_fieldData: fieldData, _role_id: options.role_id, hide_settings: options.hide_settings, tippy});
    }

    /**
     * open the droplist when sender or assignee click
     * @param event 
     * @param options 
     */
    openDropListMenu(event: MouseEvent, options: Options) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event.target as HTMLElement;
        const parentNode = element.closest('.drag-fields');
        const uuid = element.closest('.drag-fields').getAttribute('uuid');
        if(!this.restrictFieldsForFilling(uuid)) return;
        const fieldData: Field = this.globalService.fields_data[uuid];
        if(fieldData.tag_view === "1"){
            return false;
        }
        if (fieldData.selected_for_role_id == options.role_id || (fieldData.selected_for_role_id == -1 || document.querySelector('.edit-template'))) {
            const droplistDropdown = parentNode.querySelector('.droplist-dropdown') as HTMLElement;
            document.querySelectorAll('.droplist-dropdown').forEach((droplist) => {
                if (droplist != droplistDropdown) {
                    this.renderer.addClass(droplist, 'hidden');
                }
            });
            if (element && !element.classList.contains('ng-option-label') && !element.classList.contains('search-drop-value')) {
                if(droplistDropdown){
                    this.globalService.toggleClass(droplistDropdown, 'hidden');
                }
                const dropDownHeader = parentNode.querySelector('.ng-dropdown-header');
                if (fieldData.options.length >= 10) {
                    if(dropDownHeader)this.renderer.removeClass(dropDownHeader, 'hidden');
                } else {
                    if(dropDownHeader)this.renderer.addClass(dropDownHeader, 'hidden');
                }
                const view = this.searchDropList(fieldData.options, fieldData);
                const ngDropdownCustomOptions = parentNode.querySelector('.ng-dropdown-custom-options');
                this.renderer.setProperty(ngDropdownCustomOptions, 'innerHTML', view);
                domHelperService.initializeEventListener('.ng-dropdown-custom-options .ng-option', 'click', 'selectDropDownOption', { role_id: options.role_id });
            }
        }
    }

    /**
     * select the drop down value
     * @param event 
     * @param options 
     */
    selectDropDownOption(event: MouseEvent) {
        event.stopPropagation();
        const element = event.target as HTMLElement;
        const parentNode = element.closest('.drag-fields');
        const uuid = element.closest('.drag-fields').getAttribute('uuid');
        const fieldData: Field = this.globalService.fields_data[uuid];
        const optionElement = element.closest('.ng-option');
        if (!optionElement) {
            return;
        }
        const optionLabel = optionElement.textContent.trim();
        const metadataId = optionElement.getAttribute('option_uuid');
        const droplistDropdown = parentNode.querySelector('.droplist-dropdown');
        const searchDropValue = parentNode.querySelector('.search-drop-value');
        const selecedOptionLabel = parentNode.querySelector('.selected-option-label');
        const dropdownCustomOptions = parentNode.querySelector('.ng-dropdown-custom-options');
        const droplist = this.globalService.findDroplistById(uuid, metadataId);
        const droplistValue = droplist?.value || null;
        if(fieldData?.multi_select === 1){
           this.hanleMultiSelectDroplistTrigger(uuid, fieldData, droplistValue, selecedOptionLabel, dropdownCustomOptions);
        } else {
            this.renderer.addClass(droplistDropdown, 'hidden');
            this.renderer.setProperty(searchDropValue, 'value', '');
            this.renderer.setProperty(selecedOptionLabel, 'textContent', (fieldData.tag_view == "1" && !optionLabel) ? this.globalService.generateTagText(uuid) : optionLabel)
            if (this.globalService.fields_data[uuid]) {
                this.globalService.updateField(uuid, { value: droplistValue, selected_option_id: droplist?.id });
                applyRelations(uuid, this.globalService);
            }
            if(dropdownCustomOptions){
                this.clearDropDownCustomOptions(dropdownCustomOptions);
            }
            this.emitter.patchData({ uuid: uuid, value: droplistValue, refresh: 1 });   
        }
        generateCalculation(uuid, this.globalService, true);
        this.validationHandlerService.resetFieldHighlight(uuid);
    }


    /**
     * Clearing custom options after releasing focus from droplist
     * @param dropdownCustomOptions 
     */
    private clearDropDownCustomOptions(dropdownCustomOptions: Element) {
       this.renderer.setProperty(dropdownCustomOptions, 'innerHTML', '');
    }




    /**
     * Handle Multi select droplist click event from editor
     * @param uuid 
     * @param fieldData 
     * @param optionLabel 
     * @param selecedOptionLabel 
     * @param dropdownCustomOptions 
     */
    private hanleMultiSelectDroplistTrigger(uuid: string, fieldData: Field, optionLabel: string, selecedOptionLabel: Element, dropdownCustomOptions: Element){
        let value = [];
        if (fieldData?.value && Array.isArray(fieldData.value)) {
            value = [...value, ...fieldData.value];
        }
        const valueExists = value.includes(optionLabel);
        
        if (optionLabel) {
            if (valueExists) {
                value = value.filter(x => x !== optionLabel);
            } else {
                value.push(optionLabel);
            }
        } else {
            value = [];
        }
        const refactoredDroplistValue = this.globalService.refactorDroplistValue(value, fieldData);
        const displayText = (fieldData.tag_view === "1" && !optionLabel)
                            ? this.globalService.generateTagText(uuid)
                            : refactoredDroplistValue.selectedNames.map(v => `<span class="multiselect-selected-options">${v}</span>`).join('');

        this.renderer.setProperty(selecedOptionLabel, 'innerHTML', displayText);
        this.activeMutliChoiceSelectedOption(refactoredDroplistValue.selectedNames, fieldData, dropdownCustomOptions);
        const filteredValue = refactoredDroplistValue.selectedValue.length ? refactoredDroplistValue.selectedValue : '';
        if (this.globalService.fields_data[uuid]) {
            this.globalService.updateField(uuid, { value: filteredValue, selected_option_id: refactoredDroplistValue.selectedOptionid });
            applyRelations(uuid, this.globalService);
            this.emitter.patchData({ uuid, value: filteredValue, refresh: 1 });
        }
        if(dropdownCustomOptions && fieldData?.multi_select !== 1){
            this.clearDropDownCustomOptions(dropdownCustomOptions);
        }
        this.validationHandlerService.resetFieldHighlight(uuid);
    }


    /**
     * Updates the visual state of multi-choice dropdown options based on the selected values.
     * 
     * This method iterates through the options of a given field and applies or removes
     * the 'active-option' CSS class to the corresponding dropdown elements based on whether
     * their names are included in the provided selection array.
     * 
     * @param value - An array of selected option names.
     * @param fieldData - The field containing the options to be updated.
     * @param dropdownCustomOptions - The DOM element representing the dropdown options container.
     */
    activeMutliChoiceSelectedOption(value:string[], fieldData: Field, dropdownCustomOptions: Element){
        fieldData.options.forEach((option) => {
            if(value.includes(option?.name)) {
                this.renderer.addClass(dropdownCustomOptions.querySelector(`.ng-option[option_uuid="${option.id}"]`), 'active-option');
            }else{
                this.renderer.removeClass(dropdownCustomOptions.querySelector(`.ng-option[option_uuid="${option.id}"]`), 'active-option');
            }
        })
    }

    private apiFieldGetArugmentedElement(input: HTMLInputElement): typeof input & {
        _suggestionBox?: HTMLDivElement;
        _fetchedOptions?: { option_name: string }[];
        _outsideClickListenerAdded?: boolean;
        _suggestionVisible?: boolean;
        } {
        return input as typeof input & {
            _suggestionBox?: HTMLDivElement;
            _fetchedOptions?: { option_name: string }[];
            _outsideClickListenerAdded?: boolean;
            _suggestionVisible?: boolean;
        };
    }

    private apiFieldResolveInputElement(
        event: Event,
        uuid: string,
        inputRef?: HTMLInputElement
        ): HTMLInputElement | null {
        if (inputRef) return inputRef;
        const target = event.target as HTMLElement;

        if (target.tagName === 'INPUT') return target as HTMLInputElement;

        return document.querySelector(`.edit-template-right-menu-fields[uuid="${uuid}"]`) as HTMLInputElement;
    }

    private apiFieldCreateSuggestionBox(input: HTMLInputElement, fieldType: string): HTMLDivElement {
        const box = document.createElement('div');
        Object.assign(box.style, {
            position: 'absolute',
            background: 'white',
            border: '1px solid #ccc',
            zIndex: (fieldType === 'tagPopoverField' ? '9999': '999'),
            boxSizing: 'border-box',
            maxHeight: '200px',
            overflowY: 'auto',
            display: 'none',
        });

        document.body.appendChild(box);
        this.apiFieldGetArugmentedElement(input)._suggestionBox = box;
        return box;
    }

    private apiFieldPositionSuggestionBox(input: HTMLInputElement, box: HTMLDivElement): void {
        const rect = input.getBoundingClientRect();
        box.style.left = `${rect.left + window.scrollX}px`;
        box.style.top = `${rect.bottom + window.scrollY}px`;
        box.style.width = `${input.offsetWidth}px`;
        box.style.display = 'block';

        this.apiFieldGetArugmentedElement(input)._suggestionVisible = true;
    }

    private apiFieldRenderSuggestions(
        input: HTMLInputElement,
        box: HTMLDivElement,
        list: { option_name: string }[],
        field: Field,
        fieldType: string
        ): void {
        const augmented = this.apiFieldGetArugmentedElement(input);
        box.innerHTML = '';

        list.forEach(item => {
            const option = document.createElement('div');
            option.textContent = item.option_name;
            option.style.padding = '8px';
            option.style.cursor = 'pointer';
            option.addEventListener('click', () => {

                if(fieldType === 'rightBarField'){
                    input = document.querySelector(`.edit-template-right-menu-fields[uuid="${field.uuid}"]`) as HTMLInputElement
                }

                input.value = item.option_name;
                box.style.display = 'none';
                augmented._suggestionVisible = false;
                    
                const keyupEvent = new KeyboardEvent((fieldType === "rightBarField" ? 'input' : 'keyup'), {
                    bubbles: true,
                    cancelable: true,
                    key: 'Enter'
                });
                input.dispatchEvent(keyupEvent);
            });

            option.addEventListener('mouseover', () => {
                option.style.backgroundColor = '#D8E7FA';
                option.style.color = '#0A66C2';
            });

            option.addEventListener('mouseout', () => {
                option.style.backgroundColor = 'white';
                option.style.color = '';
            });

            box.appendChild(option);
        });
    }

    private apiFieldAttachOutsideClickListener(input: HTMLInputElement, box: HTMLDivElement): void {
        const augmented = this.apiFieldGetArugmentedElement(input);
        if (augmented._outsideClickListenerAdded) return;

        augmented._outsideClickListenerAdded = true;

        document.addEventListener('click', (e: MouseEvent) => {
            const target = e.target as Node;
            if (target !== input && !box.contains(target)) {
            box.style.display = 'none';
            augmented._suggestionVisible = false;
            }
        });
    }

    onTextFieldFocus(
        event: MouseEvent | KeyboardEvent,
        options: Options,
        uuid: string = '',
        inputRef?: HTMLInputElement,
        fieldType: string = 'editorField'
        ): void 
    {
        const input = this.apiFieldResolveInputElement(event, uuid, inputRef);
        if (!input) return;

        const augmented = this.apiFieldGetArugmentedElement(input);
        if (augmented._suggestionVisible) return;

        if (!uuid) {
            const parent = input.closest('.drag-fields');
            if (!parent) return;
            uuid = parent.getAttribute('uuid') ?? '';
            if (!uuid) return;
        }

        const field = this.globalService.fields_data[uuid];
        if (!field) return;

        if(!field?.api_field) return;
        
        const suggestionBox = augmented._suggestionBox ?? this.apiFieldCreateSuggestionBox(input, fieldType);
        this.apiFieldPositionSuggestionBox(input, suggestionBox);
        this.apiFieldAttachOutsideClickListener(input, suggestionBox);

        const fieldTypeId = field.selected_field_type_id;

        if (this.apiFieldCache.has(fieldTypeId)) {
            const cachedOptions = this.apiFieldCache.get(fieldTypeId)!;
            augmented._fetchedOptions = cachedOptions;
            this.apiFieldRenderSuggestions(input, suggestionBox, cachedOptions, field, fieldType);
        } else if (field.api_field) {

            const handleResponse = (response: JsonFileDTO) => {
                const results = response?.result ?? [];
                this.apiFieldCache.set(fieldTypeId, results);
                augmented._fetchedOptions = results;
                this.apiFieldRenderSuggestions(input, suggestionBox, results, field, fieldType);
            };
            
            if (options?.area === AreaType.Signing) {
                this.singingPageService
                .apiFieldOptions(options.role_id, fieldTypeId)
                .subscribe({ next: handleResponse });
            } else {
                this.documentFieldService
                .apiFieldOptions(fieldTypeId)
                .subscribe({ next: handleResponse });
            }
        }
    }

    /**
     * search the drop down label on keyup
     * @param event 
     * @param options 
     */
    searchDropDownLabelOnKeyUp(event: KeyboardEvent, options: Options) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event.target as HTMLInputElement;
        const parentNode = element.closest('.droplist-dropdown');
        const uuid = element.getAttribute('uuid');
        const val = element.value;
        const field:Field = this.globalService.fields_data[uuid];
        const dropDownoptions = field.options.filter((item) => {
            if (item.name) {
                return (
                    item.name.toLowerCase().indexOf(String(val).toLowerCase()) > -1
                );
            }
        });
        const view = this.searchDropList(dropDownoptions, field);
        const ngDropdownCustomOptions = parentNode.querySelector('.ng-dropdown-custom-options');
        this.renderer.setProperty(ngDropdownCustomOptions, 'innerHTML', view);
        domHelperService.initializeEventListener('.ng-option', 'click', 'selectDropDownOption', { role_id: options.role_id });
    }
    
    /**
     * add and search the droplist
     * @param options 
     */
    searchDropList(options: DroplistOptions[], field: Field): string {
        const placeholder = field?.placeholder || this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option");
        const buildTree = (list: DroplistOptions[]): DroplistTreeOption[] => {
            const map = new Map<number, DroplistTreeOption>();
            const roots: DroplistTreeOption[] = [];

            for (const item of list) {
                map.set(item.id, { ...item, children: [] });
            }

            for (const item of list) {
                const node = map.get(item.id)!;
                if (item.parent_id && map.has(item.parent_id)) {
                    const parent = map.get(item.parent_id)!;
                    parent.children.push(node);
                } else {
                    roots.push(node);
                }
            }

            return roots;
        };

        const renderOptions = (nodes: DroplistTreeOption[], level: number = 0): string => {
            let html = '';

            for (const node of nodes) {
                const indentStyle = `style="padding-left: ${level * 15}px"`;
                let activeClass = '';

                if (Array.isArray(field.value)) {
                    activeClass = field.value.includes(node.value) ? 'active-option' : field.value.includes(node.name) ? 'active-option' : '';
                } else {
                    activeClass = field.value === node.value ? 'active-option' : field.value === node.name ? 'active-option' : '';
                }

                const hidden = node.hide === 1 ? 'hidden' : '';

                html += `<div class="ng-option py-25 ${activeClass} ${hidden}" option_uuid="${node.id}">
                            <span class="ng-option-label font-small-3" ${indentStyle}>${node.name}</span>
                        </div>`;

                if (node.children.length > 0) {
                    html += renderOptions(node.children, level + 1);
                }
            }

            return html;
        };

        if (options.length === 0) {
            return `<div class="ng-option not-found pointer-none" option_uuid="0">
                        <span class="ng-option-label">${this._translocoService.translate("No records (general) - No records")}</span>
                    </div>`;
        }

        let view = `<div class="ng-option" option_uuid="0">
                        <span class="ng-option-label select-option" optionplaceholder="${placeholder}"></span>
                    </div>`;

        const tree = buildTree(options);
        view += renderOptions(tree);

        return view;
    }

    /**
     * toggle checkbox by sender or assignee
     * @param event 
     * @param options 
     */
    toggleCheckBox(event: MouseEvent) {
        const element = event.target as HTMLElement;
        const parentNode = element.closest('.checkbox-field') as HTMLElement;
        const uuid = parentNode.getAttribute('uuid');
        this.globalService.toggleClass(parentNode, 'checkbox-prechecked', (toggle) => {
            const checked = toggle ? 1 : 0;
            if (this.globalService.fields_data[uuid]) {
                this.globalService.updateField(uuid, { value: checked, pre_checked: checked });
                applyRelations(uuid, this.globalService);
                this.emitter.patchData({ uuid: uuid, value: checked, refresh: 1 });
            }
            this.validationHandlerService.resetFieldHighlight(uuid);
        })
    }

    /**
     * select the multi choice option
     * @param event 
     * @param options 
     */
    multiChoiceAction(event: MouseEvent) {
        const element = event.target as HTMLElement;
        const parentNode = element.closest('.multichoice-field') as HTMLElement;
        const uuid = parentNode.getAttribute('uuid');
        const elementParent = element.closest('.multiChoice-item') as HTMLElement;
        const metadataId = elementParent?.getAttribute('option_uuid');
        const multiChoice = this.globalService.findDroplistById(uuid, metadataId);
        let multiChoiceValue = multiChoice?.value || null;
        let multiChoiceId = multiChoice?.id || 0;
        if (this.globalService.fields_data[uuid]) {
            const multichoiceField: Field = this.globalService.fields_data[uuid];
            if (multichoiceField.multi_choice == "0") {
                parentNode.querySelectorAll('.multiChoice-item').forEach((multiChoiceItem) => {
                    this.renderer.removeClass(multiChoiceItem, 'multiChoice-active');
                });
                if(multiChoiceValue !== multichoiceField.value){
                    this.renderer.addClass(elementParent, 'multiChoice-active');
                }else{
                    multiChoiceValue = '';
                    multiChoiceId = 0;
                }
                this.globalService.updateField(uuid, { value: multiChoiceValue, selected_option_id: multiChoiceId });
                applyRelations(uuid, this.globalService);
                generateCalculation(uuid, this.globalService, true);
                this.emitter.patchData({ uuid: uuid, value: multiChoiceValue, refresh: 1 });
                this.validationHandlerService.resetFieldHighlight(uuid);
            } else if (multichoiceField.multi_choice == "1") {
                this.globalService.toggleClass(elementParent, 'multiChoice-active');
                const {values, optionsIds} = this.globalService.getOptionValues(uuid);
                this.globalService.updateField(uuid, { value: values, selected_option_id: optionsIds });
                applyRelations(uuid, this.globalService);
                generateCalculation(uuid, this.globalService, true);
                this.emitter.patchData({ uuid: uuid, value: values, refresh: 1 });
                this.validationHandlerService.resetFieldHighlight(uuid);
            }
        }

    }

    addSignature(event: MouseEvent, options: Options) {
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.drag-fields').getAttribute('uuid');
        if (this.globalService.fields_data[uuid]) {
            const field: Field = this.globalService.fields_data[uuid]
            if (field.selected_for_role_id == options.role_id || field.selected_for_role_id == -1) {
                const addSignature: NgbModalRef = this.modalService.open(SignatureBoxComponent, {
                    windowClass: 'sign-document-modal',
                    size: 'lg',
                    backdrop: 'static'
                });
                addSignature.componentInstance.hasModal = true;
                addSignature.componentInstance.roleDetail = options.roleDetail;
                addSignature.componentInstance.isEform = options?.isEform;
                addSignature.result.then(async (data: { status: boolean, signature: Signature }) => {
                    if (data.status) {
                        const signatureSelector = document.querySelector('.drag-fields[uuid="' + uuid + '"]');
                        const signatureBackgroundImage = signatureSelector.querySelector('.signature-image');
                        this.refreshFileService.refreshImage(data.signature.signature, options.role_id, options.roleDetail.roleable_id, options.isEform).subscribe({
                            next: (signatureBlob:Blob) => {
                                if(signatureBlob){
                                    const signature = window.URL.createObjectURL(signatureBlob);
                                    this.renderer.setStyle(signatureBackgroundImage, 'background-image', 'url(' + signature + ')');
                                    this.renderer.removeClass(signatureBackgroundImage, 'hidden');
                                    this.renderer.addClass(signatureSelector.querySelector('.selected-label '), 'hidden');
                                    this.globalService.updateField(uuid, { value: data.signature.signature });
                                    this.signingHelperService.setSignature(data.signature);
                                }
                            }
                        });
                    }
                }).catch(() => { });
            }
        }
    }

    /**
     * upload a attachment by recipient
     * @param event 
     * @param options 
     */
    uploadAttachment(event: MouseEvent, options: Options) {
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.attachment-block-upload').getAttribute('uuid');
        const attachmentBlock: Block = {...this.globalService.fields_data['blocks'][uuid]};
        if (element.nodeName != 'A' && (attachmentBlock.request_from == options.role_id || attachmentBlock.request_from == -1)) {
            const input = document.querySelector('input[name="' + uuid + '"]');
            this.renderer.selectRootElement(input).click();
        }
    }

    /**
     * upload a file for attachment
     * @param event 
     * @param options 
     */
    attachmentUploader(event: MouseEvent, options: Options) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event.target as HTMLInputElement;
        const attacheduuid = element.getAttribute('name');
        const files = element.files;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            // Validate file size
            if (!this.globalService.validateFileSize(file)) {
                // If a file exceeds the limit, alert and stop further processing
                this.globalService.toastrWarning(this._translocoService.translate("Toaster message for upload attachments (Template/Document/Content library section) - File exceeds the 20 MB size limit", { filename: file.name }));
                return;  // Exit the function and stop processing
            }
        }
        this.renderer.setStyle(document.body, 'cursor', 'wait');
        const formData: FormData = this.uploads.collectFormData(files);
        formData.append('location', `document/${options.roleDetail.roleable_id}/attachments/${attacheduuid}`);
        formData.append('unlink_folder', `document/${options.roleDetail.roleable_id}/attachments/${attacheduuid}`);
        formData.append('document_id', `${options.roleDetail.roleable_id}`);
        formData.append('upload_type', 'document_attachment');
        formData.append('uuid', attacheduuid);
        this.singingPageService.uploadFile(options.role_id, options.roleDetail.roleable_id, formData, options?.isEform).subscribe({
            next: async (files) => {
                const attachmentBlockUpload = document.querySelector(`.attachment-block-upload[uuid="${attacheduuid}"]`);
                const attachmentBeforeUpload = attachmentBlockUpload.querySelector('.attachment-before-upload');
                const attachmentAfterUpload = attachmentBlockUpload.querySelector('.attachment-after-upload');
                const attachmentListItems = attachmentAfterUpload.querySelector('.attachment-list-items');
                this.renderer.addClass(attachmentBeforeUpload, 'hidden');
                this.renderer.removeClass(attachmentAfterUpload, 'hidden');
                let fileView = '';
                if (Array.isArray(files)) {
                    for (let index = 0; index < files.length; index++) {
                        const uuid = this.uuid();
                        const attachmentUrl: Blob = await lastValueFrom(
                            this.refreshFileService.refreshImage(files[index].url, options.role_id, options.roleDetail.roleable_id, options.isEform)
                        );
                        if(attachmentUrl){
                            files[index].attachmentUrl = window.URL.createObjectURL(attachmentUrl);
                            fileView += this.Blocks.attachmentLinkView(files[index], uuid, attacheduuid, files[index].filename);
                            files[index] = { ...{ uuid: uuid }, ...files[index] };
                        }
                    }
                }
                this.globalService.updateBlock(attacheduuid, { files: files, is_uploaded: 1 });
                this.updateAttachmentViews(attacheduuid, [], Number(options.role_id));
                this.renderer.setProperty(attachmentListItems, 'innerHTML', fileView);
                element.value = null;
                this.renderer.setStyle(document.body, 'cursor', 'default');
                domHelperService.initializeEventListener('.delete-attachment-file', 'click', 'deleteAttachment');
                const fileNames = files.map(item => item.filename).join(' | ');
                if(!options.isEform){
                    this.singingPageService.addLog(options.role_id, { log_status: 'attached', message: fileNames }).subscribe({});
                }
            },
            error: () => {
                element.value = null;
                this.renderer.setStyle(document.body, 'cursor', 'default');
            }
        });
    }

    viewAttachment(event: MouseEvent, options: Options) {
        event.stopPropagation();
        event.preventDefault();
        const element = event.target as HTMLInputElement;
        const parentNode = element.closest('.attachment-block-upload');
        const uuid = parentNode.getAttribute('uuid');
        const attachmentBlock: Block = {...this.globalService.fields_data['blocks'][uuid]};
        window.open(element.getAttribute('href'), '_blank');
        if (attachmentBlock.request_from != options.role_id && options?.roleDetail?.recipient_role_detail?.is_sender === 0) {
            this.singingPageService.addLog(options.role_id, { log_status: 'viewed_attachment', message: element.textContent }).subscribe({});
        }
        this.updateAttachmentViews(uuid, attachmentBlock?.viewed_by ?? [], Number(options.role_id));
    }

    /**
     * Update attachment viewed by ids
     * @param uuid 
     * @param viewedBy 
     * @param roleId 
     */
    updateAttachmentViews(uuid: string, viewedBy: number[], roleId: number){
        if(!viewedBy.includes(Number(roleId))){
            viewedBy.push(Number(roleId));
            this.globalService.updateBlock(uuid, { viewed_by: viewedBy });  
        }
    }

    /**
     * delete the attachment
     * @param event 
     * @param options 
     */
    deleteAttachment(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();

        const element = event.target as HTMLElement;
        const parentNode = element.closest('.delete-attachment-file');

        const uuid = parentNode?.getAttribute('uuid');

        if (uuid) {
            this.deleteAttachmentByUuid(uuid, element);
        }
    }

    deleteAttachmentByUuid(uuid: string, targetElement?: HTMLElement): void {
        const attachmentBlock: Block = { ...this.globalService.fields_data['blocks'][uuid] };

        if (!attachmentBlock?.files?.length) {
            return;
        }

        // Assuming we're always deleting the first file
        const [fileToDelete] = attachmentBlock.files;
        const remainingFiles = attachmentBlock.files.slice(1);

        this.globalService.updateBlock(uuid, { files: remainingFiles });

        if (targetElement) {
            targetElement.closest('.attachmentBox')?.remove();
        }

        if (remainingFiles.length === 0) {
            const attachmentBlockUpload = document.querySelector(`.attachment-block-upload[uuid="${uuid}"]`);
            const attachmentBeforeUpload = attachmentBlockUpload.querySelector('.attachment-before-upload');
            const attachmentAfterUpload = attachmentBlockUpload.querySelector('.attachment-after-upload');
            this.renderer.removeClass(attachmentBeforeUpload, 'hidden');
            this.renderer.addClass(attachmentAfterUpload, 'hidden');
            const attachmentName = attachmentBlockUpload.querySelector('.attachment-name');
            if(attachmentName){
                const attachmentNameText = attachmentBlock?.attachment_label ?? this._translocoService.translate("Content block html text on attachment (Template/Document - section) - attachment");
                this.renderer.setProperty(attachmentName, 'textContent', attachmentNameText);
                this.globalService.updateBlock(uuid, { attachment_name: attachmentNameText, is_uploaded: 0});
                const attachmentService = AppInjector.get(ReusableAttachmentService);
                attachmentService.patchReusableAttachment({
                    roleId: attachmentBlock?.role_id,
                    metaDataId: attachmentBlock?.meta_data_id,
                    uuid: attachmentBlock?.uuid
                });
            }
        }

        if(fileToDelete.url.indexOf('contactAttachment') === -1){
            this.editorEmitterService.deleteAttachment.next({
                uuid,
                file_path: fileToDelete.url
            });
        }
    }    

    /**
     * upload a pdf by recipient
     * @param event 
     * @param options 
     */
    uploadUploadPdf(event: MouseEvent, options: Options) {
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.pdf-block-upload')?.getAttribute('uuid');
        const uploadPdfBlock: Block = {...this.globalService.fields_data['blocks'][uuid]};
        if (element && element.nodeName != 'A' && (uploadPdfBlock.request_from == options.role_id || uploadPdfBlock.request_from == -1)) {
            const input = document.querySelector('input[name="' + uuid + '"]');
            this.renderer.selectRootElement(input).click();
        }
    }

    /**
     * upload a pdf file
     * @param event 
     * @param options 
     */
    pdfUploader(event: MouseEvent, options: Options) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event.target as HTMLInputElement;
        const parentNode = element.closest('.upload-pdf-block');
        const pdfUuid = element.getAttribute('name');
        const pdfBlockData: Partial<Block> = {...this.globalService.fields_data['blocks'][pdfUuid]};
        let pdfBlock = '';
        const block = {};
        this.renderer.setStyle(document.body, 'cursor', 'wait');
        const formData: FormData = this.uploads.collectFormData(element.files, "file");
        this.singingPageService.uploadPdf(options.role_id, options.roleDetail.roleable_id, formData, options?.isEform).subscribe({
            next: async (pdfToImage) => {
                document.querySelectorAll(`[parent_uuid="${pdfUuid}"]`).forEach((dom: HTMLHtmlElement) => {
                    dom.remove();
                    this.globalService.deleteBlock(dom.getAttribute('uuid'));
                });
                element.value = null;
                this.renderer.setStyle(document.body, 'cursor', 'default');
                let page = 1;
                pdfBlock += this.Blocks.pdfBlockAfterUpload({ uuid: pdfUuid, hoverContent: (pdfBlockData.uploading_is == 1 ? this._translocoService.translate("Attahcment is required by tooltip (Template/Document - section) - This type is required by roleName", {type: 'PDF', roleName:options.roleDetail.role_name}) : this._translocoService.translate("Attachment settings Role can upload tooltip (Template/Document - section) - Role can upload", {roleName:options.roleDetail.role_name})), parent_uuid: pdfUuid });
                for (const url of pdfToImage) {
                    const pdfUrlBlob: Blob = await lastValueFrom(
                        this.refreshFileService.refreshImage(url.original, options.role_id, options.roleDetail.roleable_id, options.isEform)
                    );
                    if(pdfUrlBlob){
                        const pdfUrl = window.URL.createObjectURL(pdfUrlBlob);
                        const { pdfView, uuid } = this.Blocks.pdfViewBlock({ height: url?.height, contentable: false, parent_uuid: pdfUuid, pdfUrl:pdfUrl});
                        url.uuid = uuid;
                        pdfBlock += pdfView;
                        resetRelation(pdfUuid, this.globalService);
                        block[uuid] = { ...pdfBlockData, ...{files:[] ,uuid: uuid, connected_parent_conditional_id: [], url: url.original, height: url.height, parent_uuid: pdfUuid, page:page, is_parent:0 } };
                        this.globalService.fields_data['blocks'] = { ...this.globalService.fields_data['blocks'], ...block };
                        page++;
                    }
                }
                parentNode.outerHTML = pdfBlock;
                for (const key in block) {
                    const blockData = this.globalService.fields_data['blocks'][key];
                    this.refreshFileService.refreshImage(blockData?.url, options.role_id, options.roleDetail.roleable_id, options.isEform).subscribe({
                        next : (pdfUrlBlob:Blob) => {
                            if(pdfUrlBlob){
                                const pdfUrl = window.URL.createObjectURL(pdfUrlBlob);
                                this.setPdfBlockHeight(pdfUrl, blockData.uuid);
                            }
                        }
                    });
                }
                this.globalService.updateBlock(pdfUuid, { is_parent: 1, files:pdfToImage });
                domHelperService.initializeEventListener('.pdf-block-upload[uuid="' + pdfUuid + '"]', 'click', 'uploadUploadPdf', options);
                domHelperService.initializeEventListener('.remove-pdf-block[uuid="' + pdfUuid + '"]', 'click', 'deletePdfBlock', options);
                domHelperService.initializeEventListener('input.pdf-block-uploader', 'change', 'pdfUploader', options);
            },
            error: () => {
                element.value = null;
                this.renderer.setStyle(document.body, 'cursor', 'default');
            }
        })
    }

    deletePdfBlock(event: MouseEvent, options: Options) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event?.target as HTMLInputElement;
        const uuid = element?.getAttribute('uuid');
        const pdfBlock = document.querySelector(`.editor${uuid}`);
        if (!pdfBlock) {
            console.warn(`[deletePdfBlock] pdf block not found for uuid=${uuid}`);
            return;
        }
        pdfBlock?.querySelector('.after-upload-pdf')?.remove();
        const beforeUploadPdf = pdfBlock?.querySelector('.before-upload-pdf');
        this.renderer.removeClass(beforeUploadPdf, 'hidden');
        this.renderer.addClass(pdfBlock, 'pdf-block-upload');
        document.querySelectorAll(`[parent_uuid="${uuid}"]`).forEach((dom: HTMLHtmlElement) => {
            const pdfUuid = dom.getAttribute('uuid');
            const block = this.globalService.fields_data['blocks'][pdfUuid];
            this.globalService.deleteBlock(pdfUuid);
            this.editorEmitterService.deleteAttachment.next({ uuid: pdfUuid, file_path: block.url });
            dom.remove();
        });
        this.globalService.updateBlock(uuid, { files: [] });
        domHelperService.initializeEventListener('.pdf-block-upload[uuid="' + uuid + '"]', 'click', 'uploadUploadPdf', options);
        domHelperService.initializeEventListener('input.pdf-block-uploader', 'change', 'pdfUploader', options);
    }

    /**
     * set the pdf block height
     * @param imgSrc 
     * @param uuid 
     */
    setPdfBlockHeight(imgSrc: string, uuid: string) {
        if(!imgSrc) return;
        const pdfPageDefaultHeight = 1122;
        const image = new Image(810);
        image.src = imgSrc;
        image.setAttribute("id", uuid);
        image.style.display = 'none';
        image.onload = () => {
            setTimeout(() => {
                const tempDiv = document.getElementById(uuid);
                const imageEl = document.querySelector(`.editor${uuid}`);
                let height = $(`#${uuid}`).height(); //this will be change in future;
                if(height > pdfPageDefaultHeight){
                    height = pdfPageDefaultHeight;
                    const parentBlock = document.querySelector(`[uuid="${uuid}"].content-box-block.pdf-block`);
                    if(imageEl) this.renderer.addClass(imageEl, 'pdf-default-height');
                     if (parentBlock) {
                        (parentBlock as HTMLElement).style.setProperty('--pdf-bg-size', `100% ${pdfPageDefaultHeight}px`);
                    }
                }
                if(imageEl) this.renderer.setStyle(imageEl, 'min-height', `${height}px`);
                this.globalService.updateBlock(uuid, { height: height });
                this.renderer.removeChild(document.body, tempDiv);
                this.globalService.updateTheSigningPageHeightOnImageLoad();
            }, 800);
        };
        this.renderer.appendChild(document.body, image);
    }

    openContentLibraryModal(event: MouseEvent) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.content-library-modal-setting').getAttribute('uuid');
        const contentLibraryModal: NgbModalRef = this.modalService.open(ContentLibraryTabComponent, {
            size: 'lg',
        });
        contentLibraryModal.componentInstance.uuid = uuid;
        contentLibraryModal.result.then((result) => {
            timer(1000).subscribe(() => {
                domHelperService.initializeEventListener('.content-library-modal-setting', 'click', 'openContentLibraryModal');
                if (result?.status && result.status == "success") {
                    if (result?.result.length > 0) {
                        const assignRoleModal: NgbModalRef = this.modalService.open(AssignRoleComponent, {
                            size: 'lg',
                            backdrop: 'static'
                        });
                        assignRoleModal.componentInstance.fields = result?.result;
                    }
                }
            });
        });
    }

    deleteContentLibrary(event: MouseEvent) {
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.block-action-menu').getAttribute('uuid');
        const parentBox = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').closest('.rowItem');
        const boxType = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').getAttribute('type');
        this.confirmAlert(this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"), this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }), (result) => {
            if (result.isConfirmed) {
                parentBox.closest('.content-box').remove();
                this.globalService.deleteBlock(uuid);
            }
        })
    }

    openDatepicker(event: MouseEvent) {
        const element = event.target as HTMLInputElement;
        const parentNode = element.closest('.content-draggable-field');
        if (parentNode) {
            timer(500).pipe(take(1)).subscribe(() => {
                if (!parentNode.classList.contains('ui-draggable-dragging') && !parentNode.classList.contains('ui-resizable-resizing')) {
                    this.globalService.initializeFlatpicker(parentNode.querySelector('.datepicker-field'), true);
                }
            });
        }
    }

    generateSignatureForSender(event: MouseEvent) {
        const element = event.target as HTMLInputElement;
        const parentNode = element.closest('.signature-field');
        const uuid = parentNode.getAttribute('uuid');
        const field:Field = this.globalService.fields_data[uuid];
        if(![0].includes(Number(field.selected_for_role_id))){
            return;
        }
        const signatureInstance: NgbModalRef = this.modalService.open(SignatureComponent, {
            size: 'lg',
            windowClass: 'signature-modal',
        });
        signatureInstance.componentInstance.profileData = this.globalService.user_settings;
        signatureInstance.componentInstance.setSignatureType = SignatureType.DRAW;
        signatureInstance.result.then((signature:GenerateSignature) => {
            if (signature.status == 'done') {
                const findSignatureFields = document.querySelectorAll('.signature-field');
                findSignatureFields.forEach((elemenet:HTMLElement) => {
                    const signatureUuid = elemenet.getAttribute('uuid');
                    const signatureField:Field = this.globalService.fields_data[signatureUuid];
                    if(signatureField.selected_for_role_id == 0){
                        const element = document.querySelector(`.drag-fields[uuid='${signatureUuid}']`);
                        if (element) {
                            // Hide the '.selected-label' element
                            const selectedLabel = element.querySelector('.selected-label');
                            if (selectedLabel) {
                                this.renderer.addClass(selectedLabel, 'hidden');
                            }

                            // Set background image of '.signature-image'
                            const signatureImage = element.querySelector('.signature-image');
                            if (signatureImage) {
                                const senderSignatureImage: string = this.sessionImageService.getSignatureImages();
                                this.renderer.setStyle(signatureImage, 'background-image', `url(${senderSignatureImage})`);
                                this.renderer.removeClass(signatureImage, 'hidden');
                            }
                        }
                        this.globalService.updateField(uuid, { value: signature.signature.signature });
                    }
                });
            }
        })
    }

    openBlockMenu(event: MouseEvent) {
        const domHelperService = AppInjector.get(DomHelperService);
        const element = event.target as HTMLElement;
        const contentBoxBlock = element?.closest('.content-box');
        const blockSettings = element?.closest('.block-settings');
        const menuSelector = element?.closest('.open-editor-menu');
        const uuid = menuSelector?.getAttribute('uuid');
        const classtype = menuSelector?.getAttribute('classtype');
        const contenttype = menuSelector?.getAttribute('contenttype');
        const blockActionMenuElements = menuSelector?.querySelectorAll('.block-action-menu');
        blockActionMenuElements?.forEach((element: HTMLElement) => {
            this.renderer.addClass(element, 'hidden');
        });
        if(blockSettings){
            this.renderer.addClass(blockSettings, 'active');
        }
        if(contentBoxBlock){
            this.renderer.addClass(contentBoxBlock, 'active-menu');
        }
        // Remove 'block-action-menu' inside elements with the class 'open-editor-menu'
        const openEditorMenu = menuSelector?.querySelector('.open-editor-menu');
        if (openEditorMenu) {
            const blockActionMenuInEditor = openEditorMenu?.querySelector('.block-action-menu');
            if (blockActionMenuInEditor) {
                this.renderer.removeChild(openEditorMenu, blockActionMenuInEditor);
            }
        }
        if (menuSelector?.classList?.contains('other-popover')) {
            const otherMenu = document.createElement('div');
            otherMenu.innerHTML = this.popOver.appendImageBoxListPopover({ uuid: uuid, classType: classtype, contentType: contenttype });
            this.renderer.appendChild(menuSelector, otherMenu);
            this.renderer.removeClass(otherMenu.querySelector('.block-action-menu'), 'hidden');
        } else {
            const menu = document.createElement('div');
            menu.innerHTML = this.popOver.appendListingPopover({ uuid: uuid, classType: classtype, contentType: contenttype });
            if(menuSelector){
                this.renderer.appendChild(menuSelector, menu);
            }
            this.renderer.removeClass(menu.querySelector('.block-action-menu'), 'hidden');
        }
        domHelperService.initializeEventListener('.convert-page-break', 'click', 'convertToPdfOrPageBreak');
        domHelperService.initializeEventListener('.delete-content-library', 'click', 'deleteContentLibrary');
        domHelperService.initializeEventListener('.delete-attachment', 'click', 'deleteAttachmentBlock');
        domHelperService.initializeEventListener('.delete-upload-pdf-block', 'click', 'deletePdfBlockBox');
        domHelperService.initializeEventListener('.duplicate-table', 'click', 'duplicateTable');
        domHelperService.initializeEventListener('.duplicate-content-box', 'click', 'duplicateContentBox');
        domHelperService.initializeEventListener('.delete-image-box', 'click', 'deleteImageBox');
        domHelperService.initializeEventListener('.image-settings', 'click', 'openImageSettings');
        domHelperService.initializeEventListener('.page-break-settings', 'click', 'openPageBreakSettings');
        domHelperService.initializeEventListener('.field-block-settings', 'click', 'openFieldBlockSettings');
        domHelperService.initializeEventListener('.content-draggable-field', 'click', 'showFieldPopover');
        domHelperService.initializeEventListener('.content-box-settings', 'click', 'openContentBoxSettings');
        domHelperService.initializeEventListener('.form-builder-settings', 'click', 'openFormBuilderSettings');
        domHelperService.initializeEventListener('.pdf-block-settings', 'click', 'openPdfBlockSettings');
        domHelperService.initializeEventListener('.table-settings', 'click', 'openTableSettings');
        domHelperService.initializeEventListener('.product-table-settings', 'click', 'openProductTableSettings');
        domHelperService.initializeEventListener('.delete-product-table', 'click', 'deleteProductTableBlock');
        domHelperService.initializeEventListener('.product-table-summary-settings', 'click', 'openProductTableSummarySettings');
        domHelperService.initializeEventListener('.delete-product-table-summary', 'click', 'deleteProductTableSummaryBlock');
        domHelperService.initializeEventListener('.attachment-settings', 'click', 'openAttachmentOrPdfSettings');
        domHelperService.initializeEventListener('.upload-pdf-block-settings', 'click', 'openAttachmentOrPdfSettings');
        domHelperService.initializeEventListener('.delete-pdf-block', 'click', 'deletePdfContainer');
        domHelperService.initializeEventListener('.delete-content-box', 'click', 'deleteContentBox');
        domHelperService.initializeEventListener('.delete-form-builder', 'click', 'deleteFormBuilder');
        domHelperService.initializeEventListener('.delete-page-break', 'click', 'deletePageBreak');
        domHelperService.initializeEventListener('.delete-field-block', 'click', 'handleDeleteFieldBlock');
        domHelperService.initializeEventListener('.delete-table', 'click', 'deleteTable');
        domHelperService.initializeEventListener('.upload-image-modal-setting', 'click', 'uploadImageSetting');
    }

    deleteAttachmentBlock(event: MouseEvent) {
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.block-action-menu').getAttribute('uuid');
        const boxType = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').getAttribute('type');
        const currenctElement = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').closest('.attachment-block');
        this.confirmAlert(this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"), this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }), (result) => {
            if (result.isConfirmed) {
                currenctElement.remove();
                const element: HTMLElement = document.querySelector('.closeMenu') as HTMLElement;
                element?.click();
                const attachmentBlock: Block = this.globalService?.fields_data?.['blocks']?.[uuid];
                const files = Array.isArray(attachmentBlock?.files) ? attachmentBlock.files : [];
                for (const file of files) {
                    this.editorEmitterService.deleteAttachment.next({ uuid: uuid, file_path: file.url });
                }
                this.globalService.deleteBlock(uuid);
            }
        })
    }

    deletePdfBlockBox(event: MouseEvent) {
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.block-action-menu').getAttribute('uuid');
        const boxType = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').getAttribute('type');
        const currenctElement = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').closest('.upload-pdf-block');
        this.confirmAlert(this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"), this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }), (result) => {
            if (result.isConfirmed) {
                currenctElement.remove();
                const element: HTMLElement = document.querySelector('.closeMenu') as HTMLElement;
                element?.click();
                this.globalService.deleteBlock(uuid);
            }
        })
    }
    
    duplicateContentBox(event: MouseEvent){
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.block-action-menu').getAttribute('uuid');
        const parentNode = document.querySelector(`.editor${uuid}`).closest('.content-box') as HTMLElement;
        const block = {};
            if (!this.globalService.fields_data['blocks'] || (this.globalService.fields_data['blocks'] && !this.globalService.fields_data['blocks'][uuid])) {
            block[uuid] = contentBlock.block({ uuid: uuid });
            this.globalService.fields_data['blocks'] = { ...this.globalService.fields_data['blocks'], ...block };
        }
        this.proccessDuplicate(uuid, parentNode);
    }

    duplicateTable(event: MouseEvent){
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.block-action-menu').getAttribute('uuid');
        const parentNode = document.querySelector(`.editor${uuid}`).closest('.table-builder-block') as HTMLElement;
        this.proccessDuplicate(uuid, parentNode);
    }

    proccessDuplicate(uuid:string, parentNode:HTMLElement){
        const contentBoxInner = document.querySelector(`.content-box-inner[editor-uuid="${uuid}"]`);
        const currentRow = contentBoxInner.closest('.rowItem') as HTMLElement;
        const domHelperService = AppInjector.get(DomHelperService);
        const block:Block = {...this.globalService.fields_data['blocks'][uuid]};
        const newUuid = this.uuid();
        let clone: HTMLElement;
        const action = this.determineContentBoxAction(uuid);
        if(action === ContentBoxAction.None){
            return;
        }
        if(action === ContentBoxAction.CreateParent){
            const rowItemParent = this.createAParent(currentRow);
            clone = rowItemParent as HTMLElement;
        }else if(action === ContentBoxAction.CloneFullContentBox){
            clone = parentNode.cloneNode(true) as HTMLElement;
        }else {
            console.warn(`Unhandled ContentBoxAction: ${action}`);
            return;
        }
        const fieldsArray = [];
        if(block.fields && block.fields.length > 0){
            for (const field of block.fields) {
                const fieldData:Field = this.globalService.fields_data[field];
                const fieldUuid = this.uuid();
                this.globalService.fields_data[fieldUuid] = Object.assign({}, fieldData, {
                    uuid : fieldUuid,
                    connected_parent_calculation_id: [],
                    connected_parent_conditional_id: [],
                    conditional: "",
                    calculation: "",
                    linked_conditional_id: [],
                    enable_calculation: 0,
                    enable_conditional: 0,
                    hidden: 0,
                });
                fieldsArray.push(fieldUuid);
                const dragField = clone.querySelector(`.drag-fields[uuid="${field}"]`);
                if(dragField){
                    this.renderer.setAttribute(dragField, 'uuid', fieldUuid);   
                    this.renderer.setAttribute(dragField, 'data-id', fieldUuid);
                    this.renderer.removeClass(dragField, 'hidden');
                }
            }
        }
        const newBlock = Object.assign({}, block, {
            uuid:newUuid,
            fields: fieldsArray,
            connected_parent_conditional_id: [],
            hidden: 0,
            ...(block?.setting && {
                setting: {
                ...block.setting,
                uuid: newUuid,
                },
            }),

        });
        this.globalService.fields_data['blocks'][newUuid] = newBlock;
        this.cloneTheContent(clone, newUuid, parentNode, uuid, () => {
            this.globalService.initEditor({ uuid: newUuid });
            setTimeout(() => {
                this.helperService.updateDateFormatInDatePicker();
                this.globalService.contentBoxSort();
                domHelperService.initializeEventListener('.open-tag-popover', 'click', 'openTagPopover', {role_id:0, hide_settings:false});
            }, 500);
        });
    }
    
    cloneTheContent(clone:HTMLElement, newUuid:string, parentNode:HTMLElement, currentUuid:string, callback:()=>void){
        const domHelperService = AppInjector.get(DomHelperService);
        const blockSortInnerDiv = clone.querySelector('.block-sort-inner-div');
        const openEditorMenu = clone.querySelector('.open-editor-menu');
        const contentBoxInner = clone.querySelector('.content-box-inner');
        const editor = clone.querySelector(`.editor${currentUuid}`);
        const rowItem = clone.querySelector('.rowItem');
        const table = clone.querySelector(`.general-convert-to-table`);
        clone.querySelector('.block-action-btn').innerHTML = '';
        if(blockSortInnerDiv){
            this.renderer.setAttribute(blockSortInnerDiv, 'uuid', newUuid);
        }

        if(openEditorMenu){
            this.renderer.setAttribute(openEditorMenu, 'uuid', newUuid);
        }

        if(contentBoxInner){
            this.renderer.setAttribute(contentBoxInner, 'editor-uuid', newUuid);
        }

        if(editor){
            this.renderer.removeClass(editor, `editor${currentUuid}`);
            this.renderer.addClass(editor, `editor${newUuid}`);
            this.renderer.removeClass(editor, 'hidden');
            this.renderer.setAttribute(editor, 'editor-uuid', newUuid);
        }

        if(rowItem){
            this.renderer.removeClass(rowItem, 'has-relation');
        }

        if(table){
            this.renderer.setAttribute(table, 'uuid', newUuid);
            this.renderer.setAttribute(table, 'id', `rolresize${newUuid}`);
        }

        this.renderer.insertBefore(parentNode.parentNode, clone, parentNode.nextSibling);
        domHelperService.initializeEventListener('.content-box', 'mouseenter', 'mouseEnterOnContentBox');
        domHelperService.initializeEventListener('.content-box', 'mouseleave', 'mouseLeaveOnContentBox');
        domHelperService.initializeEventListener('.rowItem', 'mouseenter', 'mouseEnterOnContentBoxInner');
        domHelperService.initializeEventListener('.rowItem', 'mouseleave', 'mouseLeaveOnContentBoxInner');
        this.removeAllBlockActionMenus();
        this.globalService.setWidth(clone, false);
        if(callback){
            callback();
        }
    }

    private determineContentBoxAction(uuid: string | number): ContentBoxAction {
        // Step 1: Find the content box
        const contentBoxInner = document.querySelector(`.content-box-inner[editor-uuid="${uuid}"]`);
        if (!contentBoxInner) return ContentBoxAction.None;

        // Step 2: Find the rowItem that contains it
        const currentRow = contentBoxInner.closest('.rowItem');
        if (!currentRow) return ContentBoxAction.None;

        // Step 3: Check if inside merged row
        const mergedRow = currentRow.closest('.merged-row');
        if (mergedRow) {
            return ContentBoxAction.CreateParent;
        }

        // Step 4: Check siblings in same row
        const siblingBoxes = currentRow.querySelectorAll('.content-box-inner');
        if (siblingBoxes.length > 1) {
            return ContentBoxAction.CreateParent;
        }

        // Step 5: Check if single in parent content-box
        const parentContentBox = currentRow.closest('.content-box');
        if (parentContentBox && parentContentBox.querySelectorAll('.content-box-inner').length === 1) {
            return ContentBoxAction.CloneFullContentBox;
        }

        return ContentBoxAction.CreateParent;
    }

    private createAParent(rowItem: HTMLElement): HTMLElement {
        // Create parent container
        const editorInstance = document.createElement('div');
        editorInstance.classList.add(
            'content-box',
            'content-box-block',
            'content-editor-block',
            'marginminus70'
        );

        // Create sort-helper div
        const sortHelper = document.createElement('div');
        sortHelper.classList.add('sort-helper');
        editorInstance.appendChild(sortHelper);

        // Create content-box-row container
        const contentBoxRow = document.createElement('div');
        contentBoxRow.classList.add('content-box-row');

        // Clone the original rowItem safely and append
        const clonedRowItem = rowItem.cloneNode(true) as HTMLElement;
        contentBoxRow.appendChild(clonedRowItem);

        // Append row to editor instance
        editorInstance.appendChild(contentBoxRow);

        return editorInstance;
    }


    contentBoxInnerHandler(event: MouseEvent){
        const domHelperService = AppInjector.get(DomHelperService);
        const target = event.target as HTMLElement;
        const clickCoords = { left: event.clientX, top: event.clientY };
        if(target.closest('.content-box-inner')){
            if(!target.closest('.tiptap') && (target.closest('.content-box-inner').getAttribute('type') === "content box" || target.closest('.content-box-inner').getAttribute('type') === "table")){
                const uuid = target.closest('.content-box-inner').getAttribute('editor-uuid');
                this.globalService.initEditor({uuid:uuid, clickCoords});
                domHelperService.initializeEventListener('.open-tag-popover', 'click', 'openTagPopover', {role_id:0, hide_settings:false});
            }
        }
    }

bodyClickHandler(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedContentBox = target.closest('.content-box');
    const clickedRowItem = target.closest('.rowItem');
    const clickedBlockSettings = clickedRowItem?.querySelector('.block-settings');

    const allMenus = document.querySelectorAll('.open-editor-menu');

    allMenus.forEach(menu => {
        const menuContentBox = menu.closest('.content-box');
        const rowItem = menu.closest('.rowItem');
        const blockSettings = rowItem?.querySelector('.block-settings');
        const blockActionMenu = menu.querySelector('.block-action-menu');

        // If clicked outside this content-box, remove everything
        if (clickedContentBox !== menuContentBox) {
            if (blockActionMenu) {
                this.renderer.removeChild(menu, blockActionMenu);
            }
            if (menuContentBox) {
                this.renderer.removeClass(menuContentBox, 'active-menu');
            }
            if (blockSettings) {
                this.renderer.removeClass(blockSettings, 'active');
            }
        } else {
            // Clicked inside same content-box — clean up all other block-settings
            if (menuContentBox) {
                const allBlockSettings = menuContentBox.querySelectorAll('.block-settings');
                allBlockSettings.forEach(bs => {
                    if (bs !== clickedBlockSettings) {
                        const blockActionMenu = bs.querySelector('.block-action-menu');
                        this.renderer.removeClass(bs, 'active');
                        if (blockActionMenu) {
                            this.renderer.removeChild(bs, blockActionMenu);
                        }
                    }
                });
            }
        }
    });

    // Optional: fallback cleanup if click was fully outside
    if (!target.closest('.open-editor-menu')) {
        this.removeAllBlockActionMenus();
    }
    if(!target.closest('.fieldsPopover')){
        document.querySelectorAll('.fieldsPopover').forEach(popover => {
            this.renderer.removeChild(popover.parentNode, popover);
        });
    }
    if(!target.closest('.droplist-menu')){
        const droplistMenus = document.querySelectorAll('.droplist-dropdown');
        droplistMenus.forEach(menu => {
            this.renderer.addClass(menu, 'hidden');
        });
        const droplistDropdown = document.querySelectorAll('.ng-dropdown-custom-options');
        droplistDropdown.forEach(dropdown => {
            this.renderer.setProperty(dropdown, 'innerHTML', '');
        });
    }
}


    removeAllBlockActionMenus() {
        const allActionMenus = document.querySelectorAll('.block-action-menu');
        allActionMenus.forEach(menu => {
            this.renderer.addClass(menu, 'hidden');
            const parent = menu.closest('.open-editor-menu');
            if (parent) {
                this.renderer.removeChild(parent, menu);
            }
            const contentBoxBlock = menu?.closest('.content-box');
            const blockSettings = menu?.closest('.block-settings');
            if(contentBoxBlock){
                this.renderer.removeClass(contentBoxBlock, 'active-menu');
            }
            if(blockSettings){
                this.renderer.removeClass(blockSettings, 'active');
            }
        });
    }

    deleteImageBox(event: MouseEvent) {
        const targetElement = event;
        const uuid = (targetElement.target as HTMLElement).closest('.block-action-menu').getAttribute('uuid');
        const boxType = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').getAttribute('type');
        const parentBox = document.querySelector('.content-box-inner[uuid="' + uuid + '"]').closest('.rowItem');
        let elementToDelete: HTMLElement;
        const mergedRow = parentBox.closest('.merged-row');
        if (mergedRow) {
            // We are inside a merged row — check how many rowItems are in it
            const siblingRowItems = mergedRow.querySelectorAll('.rowItem');
            if (siblingRowItems.length > 1) {
                // Only remove this rowItem
                elementToDelete = parentBox as HTMLElement;
            } else {
                // Remove the entire merged-row (it's the only one)
                elementToDelete = mergedRow as HTMLElement;
            }
        }else {
            // Not merged — fallback to normal logic
            const siblingContentBoxes = parentBox.querySelectorAll('.content-box-inner');
            if (siblingContentBoxes.length > 1) {
                elementToDelete = parentBox as HTMLElement; // Just remove this content box
            } else {
                // Might be the last one, remove rowItem or full content-box if needed
                const parentContentBox = parentBox.closest('.content-box');
                if (parentContentBox && parentContentBox.querySelectorAll('.content-box-inner').length === 1) {
                    elementToDelete = parentContentBox as HTMLElement;
                } else {
                    elementToDelete = parentBox as HTMLElement;
                }
            }
        }
        this.confirmAlert(this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"), this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", {boxName : boxType}),  (result) => {
            if (result.isConfirmed) {
                const parentContainer = document.querySelector('.content-box-inner[uuid="' + uuid + '"]')?.closest('.content-box') as HTMLElement;
                elementToDelete.remove();
                this.deleteTheEmptyParent(parentContainer);
                this.globalService.deleteBlock(uuid);
                this.globalService.setWidth(parentContainer, true);
            }
        })
    }

    openImageSettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.imageBoxSettings);
    }
    /**
     * this method is used for whenever we disable the any event
     * @param event 
     * @returns 
     */
    emptyEvent(event: MouseEvent){
        return event;
    }

    deletePdfContainer(event: MouseEvent){
        const element = event.target as HTMLInputElement;
        const uuid = element.closest('.block-action-menu').getAttribute('uuid');
        const pdfBlock:Block = this.globalService.fields_data['blocks'][uuid];
const parentPdfBlock:Block = this.globalService.fields_data['blocks'][pdfBlock?.parent_uuid];
const files = parentPdfBlock?.files?.filter(value => value?.uuid != pdfBlock?.uuid);
        const parentBox = document.querySelector('.content-box-inner[editor-uuid="' + uuid + '"]').closest('.rowItem');
        const boxType = document.querySelector('.content-box-inner[editor-uuid="' + uuid + '"]').getAttribute('type');
        this.confirmAlert(this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"), this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }), (result) => {
            if (result.isConfirmed) {
                parentBox.closest('.content-box').remove();
                this.globalService.deleteBlock(uuid);
                this.globalService.updateBlock(pdfBlock?.parent_uuid, { files: files ?? [] });
                if(files && files.length === 0){
                    this.globalService.deleteBlock(pdfBlock?.parent_uuid);
                }
                this.editorEmitterService.deleteAttachment.next({ uuid: uuid, file_path: pdfBlock?.url });
            }
        })
    }

    deleteContentBox(event: MouseEvent) {
        const target = event.target as HTMLElement;

        // Step 1: Find UUID
        const parentWithUUID = target.closest('.contentBox-popover-container, .block-action-menu');
        const uuid = parentWithUUID?.getAttribute('uuid');
        if (!uuid) return;

        // Step 2: Find the content box element
        const contentBox = document.querySelector(`.content-box-inner[editor-uuid="${uuid}"]`);
        const boxType = contentBox?.getAttribute('type');
        if (!contentBox) return;

        // Step 3: Find the .rowItem that holds this content box
        const rowItem = contentBox.closest('.rowItem');
        if (!rowItem) return;

        // Step 4: Determine if we are in a merged-row
        const mergedRow = rowItem.closest('.merged-row');

        let elementToDelete: HTMLElement;

        if (mergedRow) {
            // We are inside a merged row — check how many rowItems are in it
            const siblingRowItems = mergedRow.querySelectorAll('.rowItem');
            if (siblingRowItems.length > 1) {
                // Only remove this rowItem
                elementToDelete = rowItem as HTMLElement;
            } else {
                // Remove the entire merged-row (it's the only one)
                elementToDelete = mergedRow as HTMLElement;
            }
        } else {
            // Not merged — fallback to normal logic
            const siblingContentBoxes = rowItem.querySelectorAll('.content-box-inner');
            if (siblingContentBoxes.length > 1) {
                elementToDelete = contentBox as HTMLElement; // Just remove this content box
            } else {
                // Might be the last one, remove rowItem or full content-box if needed
                const parentContentBox = rowItem.closest('.content-box');
                if (parentContentBox && parentContentBox.querySelectorAll('.content-box-inner').length === 1) {
                    elementToDelete = parentContentBox as HTMLElement;
                } else {
                    elementToDelete = rowItem as HTMLElement;
                }
            }
        }
        // Show confirmation
        this.confirmAlert(
            this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"),
            this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }),
            (result) => {
                if (result.isConfirmed && elementToDelete) {
                    const parentContentBox = elementToDelete.closest('.content-box') as HTMLElement;

                    this.renderer.removeChild(elementToDelete.parentElement, elementToDelete);
                    this.deleteTheEmptyParent(parentContentBox);
                    // Close any open menus
                    const closeBtn = document.querySelector('.closeMenu') as HTMLElement;
                    if (closeBtn) closeBtn.click();

                    this.globalService.deleteBlock(uuid);

                    // Resize layout
                    setTimeout(() => {
                        this.globalService.setWidth(parentContentBox, true);
                    }, 400);
                }
            }
        );
    }

    deleteFormBuilder(event: MouseEvent): void {
        const target = event.target as HTMLElement;

        // Get UUID from closest .contentBox-popover-container or .block-action-menu
        const parentWithUUID = target.closest('.contentBox-popover-container, .block-action-menu');
        const uuid = parentWithUUID?.getAttribute('uuid');
        if (!uuid) return;

        // Get type from .content-box-inner
        const contentBox = document.querySelector(`.content-box-inner[editor-uuid="${uuid}"]`);
        const boxType = contentBox?.getAttribute('type');

        // Get the element to remove
        const currentElement = contentBox?.closest('.form-builder-block');
        if (!currentElement) return;

        // Confirm and delete
        this.confirmAlert(
            this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"),
            this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }),
            (result) => {
            if (result.isConfirmed) {
                this.renderer.removeChild(currentElement.parentElement, currentElement);

                // Trigger close
                const closeMenu = document.querySelector('.closeMenu') as HTMLElement;
                closeMenu?.click();

                this.globalService.deleteBlock(uuid);
            }
            }
        );
    }

    deletePageBreak(event: MouseEvent): void {
        const target = event.target as HTMLElement;

        // Get UUID from closest .contentBox-popover-container or .block-action-menu
        const parentWithUUID = target.closest('.contentBox-popover-container, .block-action-menu');
        const uuid = parentWithUUID?.getAttribute('uuid');
        if (!uuid) return;

        // Find the .page-break-block and remove it
        const pageBreakBlock = target.closest('.page-break-block');
        if (pageBreakBlock) {
            this.renderer.removeChild(pageBreakBlock.parentElement, pageBreakBlock);
        }

        // Notify service
        this.globalService.deleteBlock(uuid);
    }

    handleDeleteFieldBlock(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const parentWithUUID = target.closest('.contentBox-popover-container, .block-action-menu');
        const uuid = parentWithUUID?.getAttribute('uuid');
        if (!uuid) return;

        this.deleteFieldBlock(uuid);
    }

    deleteFieldBlock(uuid: string | number): void {
        const contentBox = document.querySelector(`.content-box-inner[editor-uuid="${uuid}"]`);
        if (!contentBox) return;
        
        const boxType = contentBox?.getAttribute('type');

        // Step 1: Find the .rowItem that holds this content box
        const rowItem = contentBox.closest('.rowItem');
        if (!rowItem) return;

        // Step 2: Determine if we are in a merged-row
        const mergedRow = rowItem.closest('.merged-row');

        let elementToDelete: HTMLElement;

        if (mergedRow) {
            // We are inside a merged row — check how many rowItems are in it
            const siblingRowItems = mergedRow.querySelectorAll('.rowItem');
            if (siblingRowItems.length > 1) {
                // Only remove this rowItem
                elementToDelete = rowItem as HTMLElement;
            } else {
                // Remove the entire merged-row (it's the only one)
                elementToDelete = mergedRow as HTMLElement;
            }
        } else {
            // Not merged — fallback to normal logic
            const siblingContentBoxes = rowItem.querySelectorAll('.content-box-inner');
            if (siblingContentBoxes.length > 1) {
                elementToDelete = contentBox as HTMLElement; // Just remove this content box
            } else {
                // Might be the last one, remove rowItem or full content-box if needed
                const parentContentBox = rowItem.closest('.content-box');
                if (parentContentBox && parentContentBox.querySelectorAll('.content-box-inner').length === 1) {
                    elementToDelete = parentContentBox as HTMLElement;
                } else {
                    elementToDelete = rowItem as HTMLElement;
                }
            }
        }
        this.confirmAlert(
            this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"),
            this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }),
            (result) => {
                if (result.isConfirmed) {
                    const parentContentBox = elementToDelete.closest('.content-box') as HTMLElement;

                    this.renderer.removeChild(elementToDelete.parentElement, elementToDelete);

                    this.deleteTheEmptyParent(parentContentBox);
                    const closeMenu = document.querySelector('.closeMenu') as HTMLElement;
                    closeMenu?.click();
                    if(!this.globalService.fields_data[uuid]?.pinned_field){
                        this.globalService.deleteField(uuid);
                    } else {
                        this._fieldRenderService.unmarkRendered(String(uuid));
                    }
                    setTimeout(() => {
                        this.globalService.setWidth(parentContentBox, true);
                    }, 400);
                }
            }
        );
    }

    handleDeleteProductTable(event: MouseEvent): void {
        const target = event.target as HTMLElement;

        // Get UUID from closest `.block-action-menu`
        const blockMenu = target.closest('.block-action-menu');
        const tableUuid = blockMenu?.getAttribute('uuid');
        if (!tableUuid) return;

        // Get box type from <table> element
        const table = document.querySelector(`table[table-uuid="${tableUuid}"]`);
        const boxType = table?.getAttribute('tablename');

        // Get current product table block element
        const contentBox = document.querySelector(`.content-box-inner[editor-uuid="${tableUuid}"]`);
        const currentElement = contentBox?.closest('.product-table-block');
        if (!currentElement) return;

        // Show confirmation alert
        this.confirmAlert(
            this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"),
            this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }),
            (result) => {
            if (result.isConfirmed) {
                this.renderer.removeChild(currentElement.parentElement, currentElement);

                // Trigger close menu
                const closeBtn = document.querySelector('.closeMenu') as HTMLElement;
                closeBtn?.click();
            }
            }
        );
    }

    deleteTable(event: MouseEvent): void {
        const target = event.target as HTMLElement;

        // Get UUID from closest `.contentBox-popover-container` or `.block-action-menu`
        const parentWithUUID = target.closest('.contentBox-popover-container, .block-action-menu');
        const uuid = parentWithUUID?.getAttribute('uuid');
        if (!uuid) return;

        const boxType = this._translocoService.translate("Content Table box (Template/Document - section) - Table");

        // Find the element to remove: `.table-builder-block`
        const contentBox = document.querySelector(`.content-box-inner[editor-uuid="${uuid}"]`);
        const currentElement = contentBox?.closest('.table-builder-block');
        if (!currentElement) return;

        // Show confirmation
        this.confirmAlert(
            this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"),
            this._translocoService.translate("Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete", { boxName: boxType }),
            (result) => {
            if (result.isConfirmed) {
                this.renderer.removeChild(currentElement.parentElement, currentElement);

                const closeBtn = document.querySelector('.closeMenu') as HTMLElement;
                closeBtn?.click();

                this.globalService.deleteBlock(uuid);
            }
            }
        );
    }

    uploadImageSetting(event: MouseEvent): void {
        this.editTemplateFacade.templateRoute$.pipe(take(1)).subscribe((templateRoute) => {
            const target = event.target as HTMLElement;

            // Skip if the clicked element is already `.content-selected-image`
            if (target.classList.contains('content-selected-image')) return;

            const parentWithUuid = target.closest('.upload-image-modal-setting');
            const uuid = parentWithUuid?.getAttribute('uuid');
            if (!uuid) return;

            // Open modal
            const imageModalRef = this.modalService.open(UserGalleryComponent, {
                size: 'lg',
                windowClass: 'upload-image-modal',
                backdrop: 'static'
            });

            // Handle modal result
            imageModalRef.result.then((image) => {
                if (image.status === 'done') {
                    const section = this.globalService.getTheSectionByRoute(templateRoute.route).toLowerCase();
                    const sessionImage: string = this.sessionImageService.getTemplateImages(image?.image, Number(templateRoute.id), section);

                    // Remove old .uploadImageBox
                    const wrapper = document.querySelector(`.image-box-inner[uuid="${uuid}"]`);
                    const imageBox = wrapper?.querySelector('.uploadImageBox');
                    if (imageBox) {
                        this.renderer.removeChild(imageBox.parentElement, imageBox);
                    }

                    // Set new image HTML
                    const imageInner = document.querySelector(`.image-box-inner[uuid="${uuid}"]`);
                    if (imageInner) {
                        const imageContent = `<div class="content-selected-image"><img src="${sessionImage}"/></div>`;
                        this.renderer.setProperty(imageInner, 'innerHTML', imageContent);
                    }

                    // Initialize resizing & update block
                    this.globalService.initializeContentImageResize(`[uuid="${uuid}"] .content-selected-image`);
                    this.globalService.updateBlock(uuid, { file: image?.image, image_type: image?.image_type });
                }
            });
        })
    }

    openPageBreakSettings(event: MouseEvent){
                this._openSettingsMenu(event, PopoverSettingMenu.pageBreakSettings);
    }

    openFieldBlockSettings(event: MouseEvent){
        const targetElement = event.target as HTMLElement;
        const uuid = targetElement?.closest('.fieldsPopover, .form-builder-field-setting, .contentBox-popover-container, .block-action-menu')
        ?.getAttribute('uuid');
        if (!uuid) return;
        const field:Field = this.globalService.fields_data[uuid];
        const field_name = field?.field_name;
        const selected_field = field?.selected_field;
        this.editorEmitterService.triggerOpenMenuAction({rightMenuType:PopoverSettingMenu.popoverSettingMenu, fieldSettings:{
            uuid,
            field_name,
            selected_field,
        }});
        this.removeAllBlockActionMenus();
    }

    showFieldPopover(event: MouseEvent){
        const targetElement = event.target as HTMLElement;
        const uuid = targetElement?.closest('.drag-fields')?.getAttribute('uuid');
        const fieldData: Field = this.globalService.fields_data[uuid];
        if (fieldData?.tag_view === "0") {
            this.fieldsPopOver(targetElement?.closest('.drag-fields'), fieldData);
        }
    }

      /**
       * show the field popover based on view type
       * @param element 
       * @param field 
       */
    fieldsPopOver(element: HTMLElement, fieldData:Field) {
        const domHandlerService = AppInjector.get(DomHelperService);
        const fieldTypeMap: { [key: string]: string } = {
            'text-field': 'textFieldSetting',
            'checkbox-field': 'checkBoxFieldSetting',
            'droplist-field': 'droplistFieldSetting',
            'datepicker-field': 'datepickerFieldSetting',
            'signature-field': 'signatureFieldSetting',
            'multichoice-field': 'multiChoiceFieldSetting',
        };
        const fieldType = fieldTypeMap[fieldData.field] || '';
        const fieldComponent = this.fields.fieldPopOver({ class: fieldType });
        document.querySelectorAll('.fieldsPopover').forEach((ele:HTMLElement) => {
            ele.remove();
        });
        setTimeout(() => {
            this.renderer.appendChild(document.body, fieldComponent);
            const rect = (element as HTMLElement).getBoundingClientRect();
            const top = Math.floor(rect.top + window.scrollY);
            const left = Math.floor(rect.left + window.scrollX);
            const halfWidth = Math.floor((element as HTMLElement).offsetWidth / 2);
            const popoverContainer = document.querySelector(`.${fieldType}-popover-container`) as HTMLElement;
            if (!popoverContainer) {
                return;
            }
            const getPopoverHeight = popoverContainer.offsetHeight + 5;
            this.renderer.setStyle(popoverContainer, 'top', `${top - getPopoverHeight}px`);
            this.renderer.setStyle(popoverContainer, 'left', `${left + halfWidth + 10}px`);
            this.renderer.setAttribute(popoverContainer, 'uuid', element?.getAttribute('uuid'));
            domHandlerService.initializeEventListener('.field_settings', 'click', 'openFieldBlockSettings');
            domHandlerService.initializeEventListener('.remove_field', 'click', 'removeFieldPopover');
        } ,0)
    }

    removeFieldPopover(event: MouseEvent) {
        const contentTabService = AppInjector.get(ContentTabService);
        const targetElement = event.target as HTMLElement;
        const uuid = targetElement?.closest('.fieldsPopover')?.getAttribute('uuid');
        if (!uuid) return;
        contentTabService.removeField(uuid);
    }

    openContentBoxSettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.contentBoxSettingMenu);
    }

    openFormBuilderSettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.formBuilderSettingMenu);
    }

    openPdfBlockSettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.pdfSettingMenu);
    }

    openTableSettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.contentTableSettingMenu);
    }

    openProductTableSettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.productTableSettingMenu);
    }

    openAttachmentOrPdfSettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.attachmentSettingMenu);
    }

    private _openSettingsMenu(event: MouseEvent, menuType: PopoverSettingMenu) {
        const uuid = (event.target as HTMLElement).closest('.block-action-menu')?.getAttribute('uuid');
        if (uuid) {
            this.editorEmitterService.triggerOpenMenuAction({ rightMenuType: menuType, fieldSettings: { uuid } });
            this.removeAllBlockActionMenus();
        }
    }

    /**
       * Confirm alert
       * @param title 
       * @param message 
       * @param callback 
       */
    confirmAlert(title: string, message: string, callback: (result:SweetAlertResult)=>void) {
        Swal.fire({
            title: title,
            text: message,
            showCancelButton: true,
            confirmButtonColor: '#0161EF',
            cancelButtonColor: '#ccc',
            confirmButtonText: this._translocoService.translate("Sweetalert button text for confirmation deletion (Template/Document - section) - Yes delete")
        }).then((result) => {
            if (callback) {
                callback(result);
            }
        })
    }

    deleteTheEmptyParent(parentElement: HTMLElement) {
        setTimeout(() => {
            // After deletion: check if content-box is now empty
            const remainingInnerBlocks = parentElement?.querySelectorAll('.content-box-inner');
            if (parentElement && remainingInnerBlocks.length === 0) {
                const grandParent = parentElement.parentElement;
                if (grandParent) {
                    this.renderer.removeChild(grandParent, parentElement);
                }
            }
            this.removeAllBlockActionMenus();
        }, 0);
    }

    openProductLibraryModal(event: MouseEvent){
        const parentWithUuid = (event.target as HTMLElement).closest('[table-uuid]');
        if (!parentWithUuid) {
            return;
        }
        const uuid = parentWithUuid.getAttribute('table-uuid');
        const modalRef = this.modalService.open(ProductTableModalsComponent, {
            size: 'lg',
            windowClass: 'product-table-addProduct-modal',
            backdrop: 'static'
        });
        modalRef.componentInstance.blockUuid = uuid;
    }

    openProductTableSummarySettings(event: MouseEvent){
        this._openSettingsMenu(event, PopoverSettingMenu.productTableSumamrySettingMenu);
    }

    deleteProductTableBlockHelper(
        event: MouseEvent,
        boxTypeKey: string,
        blockSelector: string,
        afterDelete?: (uuid: string) => void
    ): void {
        const target = event.target as HTMLElement;
        const parentWithUUID = target.closest('.contentBox-popover-container, .block-action-menu');
        const uuid = parentWithUUID?.getAttribute('uuid');
        if (!uuid) return;

        const boxType = this._translocoService.translate(boxTypeKey);
        const contentBox = document.querySelector(`.content-box-inner[editor-uuid="${uuid}"]`);
        const currentElement = contentBox?.closest(blockSelector);
        if (!currentElement) return;

        this.confirmAlert(
            this._translocoService.translate("Sweetalert text for confirmation deletion (Template/Document - section) - Are you sure"),
            this._translocoService.translate(
                "Sweetalert message for confirmation deletion (Template/Document - section) - Do you want to delete",
                { boxName: boxType }
            ),
            (result) => {
                if (result.isConfirmed) {
                    this.renderer.removeChild(currentElement.parentElement, currentElement);
                    const closeBtn = document.querySelector('.closeMenu') as HTMLElement;
                    closeBtn?.click();
                    this.globalService.deleteBlock(uuid);
                    if (afterDelete) afterDelete(uuid);
                }
            }
        );
    }

    deleteProductTableSummaryBlock(event: MouseEvent): void {
        this.deleteProductTableBlockHelper(
            event,
            "Content product table summary (Template/Document - section) - Product Table Summary",
            ".product-table-summary-block"
        );
    }

    deleteProductTableBlock(event: MouseEvent): void {
        this.deleteProductTableBlockHelper(
            event,
            "Content product table (Template/Document - section) - Product Table",
            ".product-table-block",
            (uuid) => this.productTable.calculateAllSummaryBlockData(uuid) // Optional callback
        );
    }
}
